export default __webpack_public_path__ + "static/media/cbbSala3.4f0eea82.jpg";